import React, { ReactElement } from 'react';
import { CellTypes } from '../table.types';
import TableRow from '../TableRow/table-row';
import { TableRowProps } from '../TableRow/table-row.types';

// Build the table header as a row
const createTableHeader = (headerType: CellTypes, props: TableRowProps) => (
  <TableRow type={headerType} rowIndex={CellTypes.HEADER ? 0 : -1} {...props} />
);

const TableHeader = (props: TableRowProps) => {
  const { columnData } = props as { columnData: { groupColumns: ReactElement[]; groupTitle: string }[] };

  const columnGroups: ReactElement[] = [];
  let hasColGroupTitle: boolean = false;

  // Go through the data and build a header and potentially super-header rows
  columnData.forEach((column: { groupColumns: ReactElement[]; groupTitle: string }, i: number) => {
    const hasColGroup: boolean = !!column.groupColumns;

    if (hasColGroup) {
      const columns = column.groupColumns;
      columnGroups.push(<colgroup key={`col-${i}`} span={columns.length} />);
    }

    if (!hasColGroupTitle && column.groupTitle) {
      hasColGroupTitle = true;
    }
  });

  const tableHeader: ReactElement = createTableHeader(CellTypes.HEADER, props);

  // Determine if we need a superheader row
  let superHeader: ReactElement | null = null;
  if (hasColGroupTitle) {
    superHeader = createTableHeader(CellTypes.SUPER_HEADER, props);
  }

  return (
    <React.Fragment>
      {columnGroups}
      <thead>
        {superHeader}
        {tableHeader}
      </thead>
    </React.Fragment>
  );
};

export default TableHeader;
